import { IconButton } from "@/design-system/IconButton/IconButton";
import { useTranslation } from "@repo/shared/i18n";
import { X } from "lucide-react";
import { ButtonHTMLAttributes } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

const CloseButton = (props: Props) => {
  const { t } = useTranslation();
  return (
    <IconButton
      aria-label={t("close")}
      icon={<X className="size-5 text-neutral-100" />}
      {...props}
    />
  );
};

export default CloseButton;
